
import { useQuery } from '@tanstack/react-query';
import { getEmployeesWithoutSalary } from '../api';

const useEmployeesWithoutSalary = () => {
    return useQuery({
        queryKey: ['employeesWithoutSalary'],
        queryFn: getEmployeesWithoutSalary
    });
};

export default useEmployeesWithoutSalary;
